// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 470) return "static/css/470.48fd99788df4933b20b8.lib.css";
	if (chunkId === 686) return "static/css/686.ba9264adebb2291fa267.css";
	// return url for filenames based on template
	return undefined;
};